<template>
    <div class="mx-3 my-5 border border-leonard-grey rounded-md overflow-hidden" style="max-width: 300px;">
        <div class="pt-2 mb-3">
            <h4 class="m-0 text-center text-leonard-green">{{packageName(pkg.flyername)}}</h4>
            <p class="m-0 text-center capitalize">({{poseLimit(pkg.pose_limit)}})</p>
        </div>
        <div class="package_img flex flex-col" :class="'pkg_' + pkg.pkg_no">
            <div class="deluxe-icons" v-if="wand || download">
                <font-awesome-icon icon="wand-magic-sparkles" size="lg" class="text-leonard-green mx-1" v-if="wand" data-toggle="popover" data-trigger="click hover" data-placement="top" data-content="Celebrity Retouching Included"></font-awesome-icon>
                <font-awesome-icon icon="download" size="lg" class="text-leonard-green mr-1" v-if="download" data-toggle="popover" data-trigger="click hover" data-placement="top" data-content="Digital Downloads Included!"></font-awesome-icon>
            </div>
            <div :id="'pkg_details_' + (recommended ? 'recommended' : pkg.pkg_no)" class="flex flex-grow details">
                <div class="opacity-95 px-3 py-2 w-full">
                    <div>
                        <p class="text-center text-lg">{{pkg.preview}}</p>
                        <div class="text-base mb-2 mt-4">Includes:</div>
                    </div>
                    <ul class="list-disc list-outside text-xs p-0 m-0 px-3">
                        <li v-for="({name}, i) in pkg.contents" :key="'pc_'+i">
                            {{name}}
                        </li>
                    </ul>
                </div>
            </div>
            <div class="gradient"></div>
        </div>
        <div class="flex items-center justify-between my-4">
            <p class="rounded-r-sm px-3 py-1 shadow-inner bg-leonard-grey"><small>From:</small> <strong class="text-leonard-green">${{parseFloat(pkg.net_price).toFixed(2)}}</strong></p>
            <button type="button" class="btn text-sm text-leonard-info underline hover:no-underline focus:outline-none" @click="toggleDetails(pkg.pkg_no)">
                <font-awesome-icon icon="square-minus" class="mr-1" v-show="details"></font-awesome-icon>
                <font-awesome-icon icon="square-plus" class="mr-1" v-show="!details"></font-awesome-icon><span>{{details ? 'Hide' : 'Show'}}</span> Details
            </button>
        </div>
        <button type="button" class="font-medium transition-all duration-300 block w-full py-2 px-3 md:px-4 text-leonard-white cursor-pointer" :class="color" @click="select(pkg.pkg_no)" aria-label="Select This Package">
            Select
        </button>
    </div>
</template>

<script>
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faWandMagicSparkles, faDownload, faSquareMinus, faSquarePlus } from '@fortawesome/free-solid-svg-icons';

    export default {
        props: ['package', 'color', 'recommended'],

        data() {
            return {
                pkg: this.package,
                details: false,
                wand: false,
                download: false,
            }
        },

        created() {
            library.add(faDownload, faWandMagicSparkles, faSquareMinus, faSquarePlus);
        },

        mounted() {
            let contents = this.package.contents;

            if(contents && contents.length > 0) {
                let retouching = contents.find(({cont_code}) => cont_code === "0397" || cont_code === '0781');
                let downloads = contents.find(({cont_code}) => cont_code === "0472");

                if(retouching) this.wand = true;
                if(downloads) this.download = true;
            }
        },

        updated() {
            $('[data-toggle="popover"]').popover();
        },

        methods: {
            select(pkg_no) {
                this.$emit('selectPackage', pkg_no)
            },

            toggleDetails(pkg_no) {
                if(this.details) {
                    this.details = false;
                    $('#pkg_details_' + (!this.recommended ? pkg_no : 'recommended')).removeClass('open');
                } else {
                    this.details = true;
                    $('#pkg_details_' + (!this.recommended ? pkg_no : 'recommended')).addClass('open');
                }
            },

            packageName: function(name) {
                const posesIndex = name.indexOf('(');
                if(posesIndex !== -1) {
                    return name.substring(0, posesIndex - 1);
                }

                return name;
            },

            poseLimit: function(limit) {
                return limit === 100 ? 'Unlimited Poses' : this.plural('pose', limit, true);
            },
        },
    }
</script>

<style lang="scss" scoped>
    .package_img {
        position:relative;
        background-image: url('/images/Master.png');
        width: 300px;
        height: 400px;
        overflow: hidden;
        margin: 0 auto;
        background-position: 0 0;
        background-size: 2100px;
        border-radius: 4px;

        .deluxe-icons {
            position: absolute;
            top: 275px;
            right: 0;
        }

        .gradient {
            position: absolute;
            bottom: 0;
            height: 30px;
            width: 100%;
            background: linear-gradient(to bottom, rgba(255,255,255,0), #FFF 88%);
        }

        .img-header {
            background: linear-gradient(to bottom, rgba(0,0,0,0.5), rgba(0,0,0,0.05));
            // background: rgba(0,0,0,0.5);
            text-shadow: 1px 1px 1px rgba(0,0,0,0.5);
            border-radius: 4px;
        }

        .details {
            position: absolute;
            width: 100%;
            height: 100%;
            transform: translateY(310px);
            background: #FFF;
            .opacity-95 {
                transform: translateY(-0px);
                transition: transform 250ms ease-in-out;
                background: rgba(244,245,247,0.95);
            }
            &.open {
                .opacity-95 {
                    transform: translateY(-310px);
                }
            }
        }

        &.pkg_071, &.pkg_002 {
            background-size: 2050px;
            background-position-x: -300px;
        }
        &.pkg_072, &.pkg_003 {
            background-position-x: -600px;
        }
        &.pkg_073, &.pkg_004 {
            background-position-x: -900px;
        }
        &.pkg_074, &.pkg_005 {
            background-position-x: -1207px;
            background-position-y: -20px;
        }
        &.pkg_075, &.pkg_006 {
            background-position-x: -1525px;
            background-position-y: -15px;
        }
        &.pkg_076, &.pkg_007 {
            background-size: 2300px;
            background-position-x: -1980px;
            background-position-y: -30px;
        }
    }

    ul {
        column-count: 2;
        li {
            break-inside: avoid-column;
            page-break-inside: avoid;
        }
    }
</style>
